<script lang="ts">
  import { Col, Card } from "sveltestrap";
  import * as SvgIcon from "../../../Data/SvgIcon/SvgIcon";
  import { India, kolkata } from "../../../utils/Constant/Constant";
  import { onMount } from "svelte";

  interface clocks {
    sec: number,
    min: number,
    hour: number,
    date: boolean|null|number,
    month: string | undefined,
    year: boolean|null|number,
}
  const clockset:clocks = {
    sec: 0,
    min: 0,
    hour: 0,
    date: null,
    month: null,
    year: null,
}
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  function clock() {
    const cd = new Date();
    clockset.hour = 30 * (cd.getHours() % 12 + cd.getMinutes() / 60);
    clockset.min = 6 * cd.getMinutes();
    clockset.sec = 6 * cd.getSeconds();
    clockset.date = cd.getDate();
    clockset.month = months[cd.getMonth()];
    clockset.year = cd.getFullYear();
    if (document.getElementById('sec') !== null && document.getElementById('min') !== null && document.getElementById('hour') !== null) {
        document.getElementById('sec').style.cssText = '-webkit-transform:rotate(' + clockset.sec + 'deg);';
        document.getElementById('min').style.cssText = '-webkit-transform:rotate(' + clockset.min + 'deg);';
        document.getElementById('hour').style.cssText = '-webkit-transform:rotate(' + clockset.hour + 'deg);';
    }
    setTimeout(clock, 10);
}

  onMount(() => {
    clock()
  })
</script>

<Col xl="3" sm="6" class="xl-50 box-col-6">
  <Card>  
    <div class="mobile-clock-widget">
      <div class="bg-svg">
        {@html SvgIcon["Clock"]}
      </div>
      <div>
        <ul class="clock" id="clock">
          <li class="hour" id="hour" ></li>
          <li class="min" id="min" ></li>
          <li class="sec" id="sec" ></li>
        </ul>
        <div class="date f-24 mb-2" id="date">
          <span id="monthDay">{ clockset.month } { clockset.date } </span>
          <span id="year">,{clockset.year}</span>
        </div>
        <div>
          <p class="m-0 f-14 text-light">{kolkata}, {India}</p>
        </div>
      </div>
    </div>
  </Card>
</Col>
